"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isIProvideValues = void 0;
const IProduceValueEvents_1 = require("./IProduceValueEvents");
function isIProvideValues(valueProvider) {
    if (typeof valueProvider.getValue !== "function") {
        return false;
    }
    if (typeof valueProvider.getStatus !== "function") {
        return false;
    }
    if (!(0, IProduceValueEvents_1.isIProduceValueEvents)(valueProvider)) {
        return false;
    }
    return true;
}
exports.isIProvideValues = isIProvideValues;
//# sourceMappingURL=IProvideValues.js.map